<div class="d-flex justify-content-between align-items-start mb-3">
  <div>
    <h1
      class="fs-4 mb-1"
      i18n="@@navTileAdmin"
    >Kachelverwaltung</h1>
    <p
      class="text-muted mb-0"
      i18n="@@tilesAdminPageDescription"
    >Verwalte die Kacheln, die im Portal für Mandanten und Nutzer sichtbar sind.</p>
  </div>
  <div class="d-flex gap-2">
    <button
      *ngIf="imageGenerationAvailable"
      pButton
      type="button"
      [outlined]="true"
      (click)="imageBackfillVisible = true"
    ><i
        class="ri-sparkling-line me-1"
        aria-hidden="true"
      ></i><span i18n="@@tileImageBackfillOpen">Bilder generieren</span></button>
    <button
      pButton
      (click)="open()"
      i18n="@@createWebTile"
    >
      Weblink-Kachel hinzufügen
    </button>
  </div>
</div>

<app-tile-image-backfill
  [(visible)]="imageBackfillVisible"
  (changed)="onWebTileSaved()"
></app-tile-image-backfill>

<ng-template
  #colorPicker
  let-data="data"
>
  <div class="form-group">
    <label
      class="form-label"
      for="color"
      i18n="@@tilesAdminColor"
    >Akzentfarbe</label>
    <span class="text-danger">*</span>
    <br>
    <input
      id="color"
      [(ngModel)]="data.color"
      type="color"
    >
  </div>
</ng-template>

<ng-template
  #previewTpl
  let-data="data"
>
  <h2
    class="fs-6 text-muted"
    i18n="@@tilesAdminPreview"
  >Kachel-Vorschau</h2>
  <app-tile-image-editor
    class="d-block mb-1"
    [tile]="data"
    [active]="editVisible"
    (iconClick)="openIconPicker(data)"
  ></app-tile-image-editor>
</ng-template>

<ng-template
  #kindInfoTpl
  let-data="data"
>
  <p class="tile-preview-hint">
    <ng-container *ngIf="data.kind === 'application'; else linkKindTpl">
      <span i18n="@@tilesAdminKindApplicationInfo">Verknüpft mit einer bestehenden Application (Cross-App Access Check
        aktiv). Der Verknüpfungstyp kann nach dem Anlegen nicht mehr geändert werden.</span>
      <br>
      <span i18n="@@tilesAdminApplicationTileNotDeletable">Application-Kacheln können im Portal nicht gelöscht werden
        — die
        echte Logto-Application bleibt bestehen. Entferne stattdessen ihre Mandanten-Zuweisungen.</span>
    </ng-container>
    <ng-template #linkKindTpl>
      <span i18n="@@tilesAdminKindLinkInfo">Einfacher Link ohne echte Application dahinter.</span>
    </ng-template>
  </p>
</ng-template>

<ng-template
  #customPermissionsTpl
  let-data="data"
>
  <div class="tile-custom-permissions mb-3">
    <span
      class="form-label d-block mb-1"
      i18n="@@tilesAdminCustomPermissionsLabel"
    >Zusätzliche Rechte dieser Kachel</span>
    <p
      class="tile-preview-hint mb-2"
      i18n="@@tilesAdminCustomPermissionsHint"
    >Frei definierbare, kachel-eigene Rechte (z.B. "Darf Einträge editieren") — unabhängig von den
      Rollen oben. Werden pro Nutzer in der Nutzerverwaltung vergeben.</p>
    <div
      class="d-flex align-items-center justify-content-between gap-2 mb-1"
      *ngFor="let cp of data.customPermissions"
    >
      <span class="tile-custom-permission-entry">
        <strong>{{cp.label}}</strong>
        <code class="ms-1 text-muted">{{cp.key}}</code>
      </span>
      <button
        pButton
        type="button"
        severity="danger"
        text="true"
        icon="ri-close-line"
        (click)="removeCustomPermission(cp.key)"
        i18n-pTooltip="@@globalRemove"
        pTooltip="Entfernen"
        tooltipPosition="top"
      ></button>
    </div>
    <div class="d-flex gap-2 align-items-end mt-2">
      <div class="flex-grow-1">
        <label
          class="form-label mb-0 small"
          i18n="@@tilesAdminCustomPermissionKeyLabel"
        >Key</label>
        <input
          type="text"
          class="form-control form-control-sm"
          [(ngModel)]="newCustomPermissionKey"
          [ngModelOptions]="{standalone: true}"
          placeholder="edit-entries"
        />
      </div>
      <div class="flex-grow-1">
        <label
          class="form-label mb-0 small"
          i18n="@@tilesAdminCustomPermissionLabelLabel"
        >Bezeichnung</label>
        <input
          type="text"
          class="form-control form-control-sm"
          [(ngModel)]="newCustomPermissionLabel"
          [ngModelOptions]="{standalone: true}"
          i18n-placeholder="@@tilesAdminCustomPermissionExample"
          placeholder="Darf Einträge editieren"
        />
      </div>
      <button
        pButton
        type="button"
        [disabled]="!newCustomPermissionKey.trim() || !newCustomPermissionLabel.trim()"
        (click)="addCustomPermission()"
        i18n="@@globalAdd"
      >Hinzufügen</button>
    </div>
  </div>
</ng-template>

<!-- GitHub-Repository der Kachel-App: Ziel für "Feedback / Fehler melden" (server/src/feedback).
     Nur hier (Superadmin, globale Kacheln) pflegbar; leer = Fallback-Repository. -->
<ng-template
  #repositoryTpl
  let-data="data"
>
  <div
    class="tile-repository mb-3"
    *ngIf="data.kind === 'application'"
  >
    <label
      class="form-label"
      for="repository"
      i18n="@@tilesAdminRepositoryLabel"
    >GitHub-Repository</label>
    <input
      id="repository"
      name="repository"
      type="text"
      class="form-control"
      placeholder="reflact/mein-repo"
      pattern="[A-Za-z0-9_.-]+/[A-Za-z0-9_.-]+"
      maxlength="200"
      autocomplete="off"
      [(ngModel)]="data.repository"
      #repositoryModel="ngModel"
    >
    <p
      class="tile-preview-hint mt-1 mb-0"
      [class.text-danger]="repositoryModel.invalid"
      i18n="@@tilesAdminRepositoryHint"
    >Format owner/name. Feedback und Fehlermeldungen aus dieser Kachel werden dort als GitHub-Issue angelegt.</p>
  </div>
</ng-template>

<ng-template
  #mandantAssignmentsTpl
  let-data="data"
>
  <div class="tile-mandant-assignments mb-3">
    <span
      class="form-label d-block mb-1"
      i18n="@@tilesAdminMandantsAssignedLabel"
    >Kachel-Pools der Mandanten ({{getMandantCount(data)}})</span>
    <ng-container *ngIf="getMandantCount(data) > 0; else noMandantsTpl">
      <span
        class="badge tile-mandant-chip me-1 mb-1"
        *ngFor="let mandant of getMandantsForTile(data)"
      >
        {{mandant.name}}
        <span
          class="tile-mandant-chip__status"
          [class.tile-mandant-chip__status--active]="isTileActiveForMandant(data, mandant)"
          [class.tile-mandant-chip__status--partial]="!isTileActiveForMandant(data, mandant) && getIndividualAccessCountForMandant(mandant) > 0"
          [ngSwitch]="true"
        >
          <ng-container
            *ngSwitchCase="isTileActiveForMandant(data, mandant)"
            i18n="@@tilesAdminMandantVisibleForAll"
          >Sichtbar für alle</ng-container>
          <ng-container
            *ngSwitchCase="getIndividualAccessCountForMandant(mandant) > 0"
            i18n="@@tilesAdminMandantIndividualGrant"
          >{{ getIndividualAccessCountForMandant(mandant) }} Freigabe(n)</ng-container>
          <ng-container
            *ngSwitchDefault
            i18n="@@tilesAdminMandantNotActive"
          >Nicht aktiviert</ng-container>
        </span>
      </span>
    </ng-container>
    <ng-template #noMandantsTpl>
      <span
        class="text-muted small"
        i18n="@@tilesAdminMandantsNone"
      >In keinem Kachel-Pool enthalten.</span>
    </ng-template>
  </div>
</ng-template>

<ng-template #individualAccessTpl>
  <div class="tile-individual-access">
    <span
      class="form-label d-block mb-1"
      i18n="@@tilesAdminIndividualAccessLabel"
    >Personen mit Zugriff ({{individualAccess.length}})</span>
    <div
      *ngIf="loadingIndividualAccess"
      class="text-muted small"
    >
      <i class="ri-loader-4-line ri-spin"></i>
    </div>
    <ng-container *ngIf="!loadingIndividualAccess">
      <ng-container *ngIf="individualAccess.length > 0; else noIndividualAccessTpl">
        <div
          class="tile-individual-access-row"
          *ngFor="let grant of individualAccess"
        >
          <span class="fw-medium">{{grant.name}}</span>
          <span class="text-muted small">{{grant.email}}</span>
          <app-test-user-badge [email]="grant.email"></app-test-user-badge>
          <span class="badge tile-mandant-chip">{{grant.mandantName}}</span>
        </div>
      </ng-container>
      <ng-template #noIndividualAccessTpl>
        <span
          class="text-muted small"
          i18n="@@tilesAdminIndividualAccessNone"
        >Niemandem individuell zugewiesen.</span>
      </ng-template>
    </ng-container>
  </div>
</ng-template>

<div>
  <p-card>
    <p-table
      [value]="(frontendService.results$ | async) ?? []"
      dataKey="_id"
      styleClass="p-datatable-sm"
      selectionMode="single"
      [(selection)]="selectedTile"
      (onRowSelect)="selectTileForEdit($any($event.data))"
    >
      <ng-template #header>
        <tr>
          <th i18n="@@tilesAdminIconColumn">Icon</th>
          <th pSortableColumn="name">{{getColumnLabel('name')}} <p-sort-icon field="name" /></th>
          <th i18n="@@tilesAdminKind">Verknüpfungstyp</th>
          <th i18n="@@tilesAdminMandantsColumn">Mandanten</th>
          <th pSortableColumn="subtext">{{getColumnLabel('subtext')}} <p-sort-icon field="subtext" /></th>
          <th pSortableColumn="url">{{getColumnLabel('url')}} <p-sort-icon field="url" /></th>
        </tr>
      </ng-template>
      <ng-template
        #body
        let-tile
      >
        <tr [pSelectableRow]="tile">
          <td>
            <span
              class="tile-admin-table-icon-badge"
              [ngStyle]="{'background-color': tile.color ?? '#6366f1'}"
            >
              <app-tile-icon [tile]="tile"></app-tile-icon>
            </span>
          </td>
          <td>{{tile.name}}</td>
          <td>
            <span
              class="badge tile-kind-badge"
              [class.tile-kind-badge--application]="tile.kind === 'application'"
            >{{getKindBadgeLabel(tile)}}</span>
          </td>
          <td>
            <span
              class="badge tile-mandant-count-badge"
              [title]="getMandantNamesTitle(tile)"
            >{{getMandantCount(tile)}}</span>
          </td>
          <td>{{tile.subtext}}</td>
          <td>{{tile.url|shorty: 30}}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td
            colspan="6"
            i18n="@@tilesAdminNoData"
          >Noch keine Kacheln vorhanden. Erstelle deine erste Kachel.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<app-tile-icon-picker
  [(visible)]="iconPickerVisible"
  [color]="iconPickerTile?.color ?? '#6366f1'"
  (accepted)="onIconPickerAccepted($event)"
></app-tile-icon-picker>

<p-drawer
  #editTileDrawer
  [(visible)]="editVisible"
  position="right"
  [style]="{width: 'min(880px, 95vw)'}"
  (onHide)="closeTileDetail()"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@globalEdit"
    >Bearbeiten</span>
  </ng-template>
  <div *ngIf="editTile as selected">
    <app-form
      #tileForm
      [data]="selected"
      [showActions]="false"
      [hideDeleteButton]="!!selected.protected"
      [tabs]="tileEditFormTabs"
      [formFields]="[
        { fieldName: 'preview', type: 'template', tab: 'appearance', options: {template: previewTpl} },
        { fieldName: 'name', type: 'text', required: true, tab: 'appearance', options: {widthClass: 'col-md-8'}  },
        { fieldName: 'color', required: true, type: 'template', tab: 'appearance', options: {template: colorPicker, widthClass: 'col-md-4'} },
        { fieldName: 'subtext', type: 'text', required: true, tab: 'appearance'  },
        { fieldName: 'kindInfo', type: 'template', tab: 'settings', options: {template: kindInfoTpl} },
        { fieldName: 'url', type: 'text', required: true, tab: 'settings'  },
        { fieldName: 'openInNewTab', type: 'switch', tab: 'settings', options: {widthClass: 'col-md-6'}},
        { fieldName: 'customPermissions', type: 'template', tab: 'settings', options: {template: customPermissionsTpl} },
        { fieldName: 'repository', type: 'template', tab: 'settings', options: {template: repositoryTpl} },
        { fieldName: 'mandantAssignments', type: 'template', tab: 'info', options: {template: mandantAssignmentsTpl} },
        { fieldName: 'individualAccess', type: 'template', tab: 'info', options: {template: individualAccessTpl} }
      ]"
      [translatedLabels]="this.translatedLabels"
      (submit)="updateTile($event)"
      (delete)="deleteTile($event)"
    >
    </app-form>
  </div>
  <ng-template #footer>
    <div
      class="d-flex gap-2 justify-content-start"
      *ngIf="editTile as selected"
    >
      <button
        *ngIf="!selected.protected"
        pButton
        type="button"
        severity="danger"
        [outlined]="true"
        (click)="openDeleteDialog()"
        i18n="@@delete"
      >Löschen</button>
      <button
        pButton
        type="button"
        [outlined]="true"
        (click)="editTileDrawer.close($event)"
        i18n="@@cancel"
      >Abbrechen</button>
      <button
        pButton
        type="button"
        [disabled]="!!tileFormRef?.form?.invalid || !hasTileChanges() || tileSaving"
        [loading]="tileSaving"
        [severity]="tileSaveFeedback === 'saved' ? 'success' : undefined"
        (click)="tileFormRef?.onSubmit()"
      >
        <i
          *ngIf="tileSaveFeedback === 'saved'"
          class="ri-check-line me-1"
        ></i>
        <span
          *ngIf="tileSaveFeedback !== 'saved'"
          i18n="@@save"
        >Speichern</span>
        <span
          *ngIf="tileSaveFeedback === 'saved'"
          i18n="@@globalSavedShort"
        >Gespeichert</span>
      </button>
    </div>
  </ng-template>
</p-drawer>

<p-dialog
  header="Kachel endgültig löschen"
  i18n-header="@@tilesAdminDeleteDialogHeader"
  [(visible)]="deleteDialogVisible"
  [modal]="true"
  appendTo="body"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [closable]="!deleting"
  [style]="{width: '560px', maxWidth: '95vw'}"
>
  <ng-container *ngIf="editTile as selected">
    <p i18n="@@tilesAdminDeleteDialogIntro">Die Logto-Application wird gelöscht und die Kachel aus allen Mandanten entfernt. Logins über diese Application funktionieren danach nicht mehr. Das lässt sich nicht rückgängig machen.</p>
    <dl class="row mb-2">
      <dt
        class="col-sm-5"
        i18n="@@tilesAdminDeleteDialogApplication"
      >Logto-Application</dt>
      <dd class="col-sm-7">{{selected.name}} · <code>{{selected._id}}</code> · {{selected.applicationType ?? '–'}}</dd>
      <dt
        class="col-sm-5"
        i18n="@@tilesAdminDeleteDialogMandants"
      >Betroffene Mandanten</dt>
      <dd class="col-sm-7">{{getMandantNamesTitle(selected)}}</dd>
      <dt
        class="col-sm-5"
        i18n="@@tilesAdminDeleteDialogIndividual"
      >Personen mit individuellem Zugriff</dt>
      <dd class="col-sm-7">{{loadingIndividualAccess ? '…' : individualAccess.length}}</dd>
    </dl>
    <p
      class="text-muted small"
      i18n="@@tilesAdminDeleteDialogExternal"
    >Coolify-Anwendung, GitHub-Repository und Env-Einträge bleiben bestehen und müssen separat entfernt werden.</p>
    <label
      for="tileDeleteConfirmName"
      class="form-label"
      i18n="@@tilesAdminDeleteDialogConfirmLabel"
    >Zum Bestätigen den Kachelnamen eingeben</label>
    <input
      id="tileDeleteConfirmName"
      pInputText
      class="w-100"
      autocomplete="off"
      [(ngModel)]="deleteConfirmName"
      [placeholder]="selected.name"
    />
  </ng-container>
  <ng-template #footer>
    <ng-container *ngIf="editTile as selected">
      <button
        pButton
        type="button"
        [outlined]="true"
        [disabled]="deleting"
        (click)="deleteDialogVisible = false"
        i18n="@@cancel"
      >Abbrechen</button>
      <button
        pButton
        type="button"
        severity="danger"
        [disabled]="!canConfirmDelete(selected)"
        [loading]="deleting"
        (click)="confirmDeleteTile(selected)"
        i18n="@@tilesAdminDeleteDialogConfirm"
      >Endgültig löschen</button>
    </ng-container>
  </ng-template>
</p-dialog>


<app-web-tile-editor
  #webTileEditor
  scope="global"
  (saved)="onWebTileSaved()"
></app-web-tile-editor>
